import { MultiValueCell } from "@/lib/utils/tableUtils";
import { getIncidentTypeModuleLabels } from "./matter-type-module-labels";
import { getIncidentTypeLabel } from "@/lib/utils/matters/incident-classification";
import { DataTableColumnHeader, ExpandableText } from "@/components/ui";
import { type IncidentType } from "@/lib/types";
import { type ColumnDef, createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper<IncidentType>();

export const incidentTypeTableColumns: ColumnDef<IncidentType>[] = [
  columnHelper.accessor("label", {
    id: "Label",
    cell: (cell) => getIncidentTypeLabel(cell.row.original),
    enableHiding: false,
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  }),
  columnHelper.accessor("incidentTypeCategoryId", {
    id: "Incident Type Category",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (cell) => cell.row.original.category?.label ?? cell.getValue() ?? "-",
  }),
  columnHelper.accessor("description", {
    id: "Description",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (cell) => {
      const value = cell.getValue();
      if (!value) {
        return "-";
      }
      return (
        <ExpandableText text={String(value)} maxLines={3} className="text-sm" />
      );
    },
  }),
  columnHelper.accessor((row) => getIncidentTypeModuleLabels(row), {
    id: "Modules",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (cell) => (
      <MultiValueCell showItemCount={3} value={cell.getValue()} />
    ),
  }),
] as ColumnDef<IncidentType>[];
